var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButchersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4386 0.753099L5.9141 20.9582L11.0362 28.4361C18.0965 23.1182 25.2625 14.5348 30.9458 5.32333L23.4385 0.753021L23.4386 0.753099ZM24.1514 3.09919C24.3591 3.10154 24.5276 3.16271 24.6641 3.25544C24.9371 3.44107 25.1671 3.83435 25.1671 4.53482C25.1671 5.93544 24.0382 7.73888 22.8501 8.29451C22.2561 8.57224 21.8586 8.51669 21.5856 8.33122C21.3126 8.14552 21.0801 7.75216 21.0801 7.05185C21.0801 5.65107 22.2114 3.84763 23.3995 3.29201C23.6966 3.15318 23.9438 3.09669 24.1514 3.09919ZM32.1934 6.08263C26.4215 15.4408 19.1663 24.158 11.8614 29.6423L15.184 34.4958C22.525 29.171 32.3168 18.6677 37.1812 9.11732L32.1933 6.08255L32.1934 6.08263ZM4.74223 21.8322C3.3491 23.1697 1.95441 24.3879 0.557617 25.4919V34.913C2.72793 32.2854 5.0423 29.0154 7.41309 25.731L4.74223 21.8321V21.8322Z",
    fill: "#EFA92B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButchersIcon);
export default __webpack_public_path__ + "static/media/butchersIcon.911903d469dee16c36a6e54e20fabcd0.svg";
export { ForwardRef as ReactComponent };